import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesEditComponent } from './roles-edit/roles-edit.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { ProjectRolesComponent } from './project-roles/project-roles.component';
import { SharedModule } from '@app/shared.module';
import { AntdModule } from '@app/antd.module';
import { FormsModule } from '@angular/forms';
import { ElementsModule } from '@app/components/elements/elements.module';

const COMPONENTS = [
	RolesEditComponent,
	UserRolesComponent,
	ProjectRolesComponent,
];

@NgModule({
	declarations: [
		...COMPONENTS,
	],
	exports: [
		...COMPONENTS,
	],
	imports: [
		CommonModule,
		SharedModule,
		AntdModule,
		FormsModule,
		ElementsModule,
	],
})
export class ProjectRolesModule { }
